import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsOptions, getEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsOptions } from '@onefootprint/fetch-dashboard';
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { type SubsectionType as Subsection, useOnboardingDocuments } from '@/components/entity-onboarding-details';
import useCurrentEntityDuplicateData from '@/entity/hooks/use-current-entity-duplicate-data';
import useCurrentEntityOtherInsights from '@/entity/hooks/use-current-entity-other-insights';

/**
 * The sections that loaded and turned out empty. They shrink to their header so a sparse
 * onboarding stays scannable. Shares its queries with the sections themselves.
 */
const useEmptySubsections = (entity, onboarding) => {
  const $ = _c(14);
  const path = {
    fpId: entity.id,
    onboardingId: onboarding.id
  };
  const isPerson = entity.kind === "person";
  const {
    data: riskSignals
  } = useQuery(getEntitiesByFpIdOnboardingsByOnboardingIdRiskSignalsOptions({
    path
  }));
  const t0 = getEntitiesByFpIdOnboardingsByOnboardingIdMatchSignalsOptions({
    path
  });
  let t1;
  if ($[0] !== isPerson || $[1] !== t0) {
    t1 = {
      ...t0,
      enabled: isPerson
    };
    $[0] = isPerson;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: matchSignals
  } = useQuery(t1);
  const {
    documents
  } = useOnboardingDocuments(entity, onboarding);
  const {
    data: dupes
  } = useCurrentEntityDuplicateData(onboarding.completedAt, isPerson);
  const {
    data: insights
  } = useCurrentEntityOtherInsights();
  const t2 = riskSignals?.length === 0;
  const t3 = dupes?.data.length === 0;
  const t4 = documents?.length === 0;
  let t5;
  if ($[3] !== matchSignals) {
    t5 = Boolean(matchSignals) && !Object.values(matchSignals ?? {}).some(Boolean);
    $[3] = matchSignals;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== insights || $[6] !== onboarding.id) {
    t6 = Boolean(insights) && !insights?.some(insight => insight.onboardingId === onboarding.id);
    $[5] = insights;
    $[6] = onboarding.id;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = {
      "risk-signals": t2,
      "duplicate-data": t3,
      documents: t4,
      "field-validations": t5,
      "other-insights": t6
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default useEmptySubsections;